
import { Component, Mixins } from 'vue-property-decorator';
import { TestimonialFilter, TestimonialOrderBy } from 'client-website-ts-library/filters';
import { View } from 'client-website-ts-library/plugins';

import TestimonialCards from '@/components/Testimonials/TestimonialCards.vue';
import ItemCycler from '@/components/Cycler/ItemCycler.vue';
import { ItemCyclerEmbeddableSlide, ItemCyclerSlide } from '@/app_code/ItemCycler';
import { Testimonial, WebsiteLevel } from 'client-website-ts-library/types';

@Component({
  components: {
    TestimonialCards,
  },
})
export default class Testimonials extends Mixins(View) {
    private filter: TestimonialFilter = new TestimonialFilter();

    mounted() {
      // this.filter = new TestimonialFilter({
      //   SearchLevel: WebsiteLevel.Franchise,
      //   SearchGuid: '62b3407f-247d-4cf5-8c2f-df832c809b5c',
      //   OrderByStatements: [TestimonialOrderBy.CreateDateAsc],
      // });
    }
}
